import moment from 'moment';

export default function getRendererValueDate(value: string | number, includeTime = false): string {
  const parsedTimestamp = Number.parseInt(`${value}`, 10);
  const d = new Date(parsedTimestamp * 1000);
  const validDate = !Number.isNaN(d.getTime());

  if (validDate) {
    return moment(d).format(includeTime ? 'L HH:mm' : 'L');
  }

  return '';
}
